export const $id = (id) => document.getElementById(id);
